export const parkingWidgetStyleProps = {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: {
        desktop: '87rem',
        base: '23rem',
        mobileXL: '50rem',
        tablet: '63rem',
    },
    minWidth: {
        desktop: '62rem',
        tablet: '51.5rem',
        mobileXL: '43rem',
        base: '22.4rem',
    },
    minHeight: {
        desktop: '62.5rem',
        tablet: '58rem',
        mobileXL: '58rem',
        base: '53rem',
    },
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'accent',
    borderRadius: '8px',
    overflow: 'auto',
    margin: 'auto',
};

export const widgetBodyStyleProps = {
    templateRows: 'repeat(2, 1fr)',
    height: {
        base: '16rem',
        mobileXL: '20rem',
        tablet: '21rem',
        desktop: '23rem',
    },
    justifyContent: 'center',
    marginX: {
        desktop: '7rem',
        tablet: '2rem',
        mobileXL: '4.25rem',
        base: 'none',
    },
    marginY: {
        desktop: '-6rem',
        tablet: '-3.5rem',
        mobileXL: '-4.25rem',
        base: '-2.5rem',
    },
};
